// Robots data (placeholder, replace with real robot projects later)
const robots = [
	{
		id: 1,
		title: '息烟仔机器人',
		category: '机器视觉',
		img: require('@/assets/images/smoke.jpg'),
	},
	//{
	//	id: 2,
	//	title: '机械臂分拣',
	//	category: '机械臂',
	//	img: require('@/assets/images/dalishi.jpg'),
	//},
	//{
	//	id: 3,
	//	title: 'SLAM建图导航',
	//	category: 'SLAM',
	//	img: require('@/assets/images/dalishi.jpg'),
	//},
	//{
	//	id: 4,
	//	title: '视觉抓取',
	//	category: '机器视觉',
	//	img: require('@/assets/images/dalishi.jpg'),
	//},
];

export default robots;
